import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { handleOAuthCallback } from "../services/cognitoAuthService";
import { useAuth0 } from "../hooks/useAuth0";

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAuthState } = useAuth0();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const oauthError = searchParams.get("error");

    if (oauthError) {
      // e.g. the user cancelled the Apple/Google sign-in prompt
      setError(searchParams.get("error_description") || oauthError);
      return;
    }

    if (!code) {
      setError("No authorization code received.");
      return;
    }

    handleOAuthCallback(code, state)
      .then(() => refreshAuthState())
      .then(() => navigate("/", { replace: true }))
      .catch((err) => {
        console.error("OAuth callback failed:", err);
        setError(err.message || "Sign-in failed. Please try again.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", px: 3, textAlign: "center" }}>
        <Typography variant="h6" color="error" gutterBottom>
          Sign-in didn't complete
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {error}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "primary.main", cursor: "pointer", fontWeight: 600 }}
          onClick={() => navigate("/login")}
        >
          Back to sign in
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Signing you in…
      </Typography>
    </Box>
  );
}
